// extracted by mini-css-extract-plugin
export var dropdownIcon = "_r9-6";
export var imgContainer = "_r9-3";
export var menuIcon = "_r9-5";
export var pillWrapper = "_r9-2";
export var pillsContainer = "_r9-1";
export var subscriptionCard = "_r9-0";
export var subscriptionLogo = "_r9-4";